import PageLoadedQueue from "../PageLoadedQueue";
import Mark from 'mark.js';


let requestAbortController = null;

/**
 * Search via ajax and optional show the flyout
 *
 * @param searchTerm
 * @param showFlyout
 * @param searchInput
 * @return void
 */
function flyoutSearch(searchTerm, showFlyout, searchInput) {
    if (requestAbortController != null) {
        requestAbortController.abort('new search started.');
    }
    requestAbortController = new AbortController();

    const url = new URL(window.searchFlyoutLink, window.location.origin);
    url.searchParams.set('searchTerm', searchTerm);

    fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'text/html'
        },
        signal: requestAbortController.signal
    })
        .then(response => response.text())
        .then(data => {
            const flyoutDom = document.createElement('div');
            flyoutDom.innerHTML = data;

            const instance = new Mark(flyoutDom);
            instance.mark(searchTerm);

            if (showFlyout === false) {
                flyoutDom.style.display = 'none';
            }

            const searchFlyoutWrapper = document.querySelector('.search-flyout-wrapper');
            if (searchFlyoutWrapper !== null) {
                searchFlyoutWrapper.remove();
            }
            searchInput.after(flyoutDom);
        });
}

const flyoutEventListeners = (searchInput: HTMLInputElement) => {
    document.body.addEventListener('click', (e) => {
        const target = (e.target as HTMLElement)?.closest('a');

        if (!target || !searchInput.parentElement.contains(target)) {
            return;
        }

        const form = searchInput.closest('form');

        /**
         * On click on .go-to-search-page submit the search form
         */
        if (target.closest('.go-to-search-page')) {
            form.submit();
            return;
        }

        /**
         * On click on .go-to-top-search-page submit the search form
         */
        if (target.closest('.go-to-top-search-page')) {
            form.insertAdjacentHTML('beforeend', '<input type="hidden" name="filter[guenstig-einkaufen]" value="Top" />');
            form.submit();
            return;
        }

        /**
         * On click on a manufacturer go to search-page and filter
         */
        if (target.closest('.flyout-manufacturer a[data-manufacturer]')) {
            const manufacturerEl = target.closest('.flyout-manufacturer a[data-manufacturer]') as HTMLElement;
            form.insertAdjacentHTML('beforeend', '<input type="hidden" name="filter[Hersteller]" value="' + manufacturerEl.dataset.manufacturer + '" />');
            form.submit();
            return;
        }

        /**
         * On click on a category go to search-page and filter
         */
        if (target.closest('.flyout-category a[data-category]')) {
            form.insertAdjacentHTML('beforeend', '<input type="hidden" name="filter[category]" value="' + target.dataset.category + '" />');
            form.submit();
            return;
        }
    });
}

const searchFlyout = (searchInput: HTMLInputElement) => {
    /**
     * Search if key in searchInput goes up
     */
    let time = 0;
    searchInput.addEventListener('keyup', (e) => {
        if (time) {
            window.clearTimeout(time);
        }
        time = window.setTimeout(() => {
            if (typeof searchInput.value != 'undefined' && searchInput.value.length >= 2) {
                flyoutSearch(searchInput.value, true, searchInput)
            }
        }, 250);
    });

    /**
     * On focusin show the flyout
     */
    searchInput.addEventListener('focusin', () => {
        const searchFlyout = searchInput.parentElement.querySelector('.search-flyout') as HTMLElement;
        if (searchFlyout) {
            searchFlyout.style.display = 'block';
        }

        const searchFlyoutBackground = searchInput.parentElement.querySelector('.search-flyout-background') as HTMLElement;
        if (searchFlyoutBackground) {
            searchFlyoutBackground.style.display = 'block';
        }
    });

    /**
     * On Search page set the input value and call flyoutSearch without showing the flyout
     * (this is for focusin)
     */
    const plandentSearchSearchResults = document.querySelector('.avency-nwd-search-searchresults[data-searchterm]') as HTMLElement;
    if (plandentSearchSearchResults) {
        const searchTerm = plandentSearchSearchResults.dataset.searchterm;
        searchInput.value = searchTerm;

        setTimeout(function () {
            flyoutSearch(searchTerm, false, searchInput);
        }, 500);
    }

    flyoutEventListeners(searchInput);
}

export function initSearchFlyout() {
    const searchInputs = document.querySelectorAll('.header .search__input') as NodeListOf<HTMLInputElement>;

    searchInputs.forEach(searchInput => {
        searchFlyout(searchInput);
    });

    /**
     * On click outside the flyout hide the flyout
     */
    document.body.addEventListener('click', function (e) {
        const target = e.target as HTMLElement;

        if (target.classList.contains('search-flyout-wrapper')) {
            return;
        }

        const flyoutBackground = document.querySelector('.search-flyout-background');
        flyoutBackground?.remove();

        const searchFlyout = document.querySelector('.search-flyout');
        searchFlyout?.remove();
    }, {passive: true});
}

PageLoadedQueue.addFunction(initSearchFlyout)
